// extracted by mini-css-extract-plugin
export default {"text":"_3CTze0EYYINlInjlu-3Cno","searchIcon":"_2SztzLVjLaP2AajgtXX1_H","exitIcon":"ifcwQ3nbK6FEEAKYDyBp-","searchBar":"Rt14N6ixjfWzlf21lugvR"};